import { FC } from "react";
import { useHalls } from "api/hooks";

import { CircularProgress, Grid2 } from "@mui/material";

import ControlledSelectionRadioGroup, {
  ControlledSelectionRadioGroupProps,
} from "./ControlledSelectionRadioGroup.tsx";

type HallsProps = Pick<ControlledSelectionRadioGroupProps, "name" | "control">;

const HallsGroup: FC<HallsProps> = (props) => {
  const { halls, isFetching } = useHalls();

  if (isFetching) {
    return (
      <Grid2 mt={2} container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    );
  }

  if (!halls) return null;

  return <ControlledSelectionRadioGroup options={halls} {...props} />;
};

export default HallsGroup;
